<template>
  <div class="dashboard">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'dashboard-page',
}
</script>

<style scoped>

</style>
